import styled from 'styled-components';

import { COLORS } from 'theme';

export const StyledDialogDescription = styled.p`
  color: ${COLORS.black50};
  font-size: ${({ theme }) => theme.fontSize.body2};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  line-height: ${({ theme }) => theme.lineHeight.body2};
  margin: 0 0 ${({ theme }) => theme.spacing.s3} 0;
`;
